'use client'

import React from 'react'
import styles from './styles.module.scss'
import TrashSvg from '@/src/assets/svgs/collection/trash.svg'
import VoucherSvg from '@/src/assets/svgs/collection/voucher.svg'
import { usePathname } from 'next/navigation'

interface Props {
    name: string,
    remove: () => void,
    className?: string
}

export default function RemoveCoupon({ name, remove, className }: Props) {
    const pathname = usePathname()

    return (
        <div className={`${styles.removeCouponArea} ${!pathname.startsWith('/carrinho') ? styles.notCartRoute : ''} ${className ?? ""}`}>
            {!pathname.startsWith('/carrinho') ? <VoucherSvg className={styles.discountSvg} /> : <></>} <label>{name}</label> <TrashSvg className={styles.removeCoupon} onClick={remove} />
        </div>
    )
}
